module.exports = __webpack_public_path__ + "static/gloves_of_missile_snaring-5dfe08c092c497d994fda54e2c9a821a.jpeg";